module.exports = __webpack_public_path__ + "static/media/red-create-post.880d3f6f.svg";